import { memo, useMemo } from 'react';
import { Label, type LabelProps } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import { type OpenApiSchemaPromocodeGroup } from '#shared/api/schema';
import { PROMOACTIONS_STATUSES, STATUS_ICON_MAP } from '../../lib/constants';

export interface PromocodeStatusLabelProps
    extends TestProps,
        Omit<LabelProps, 'children'>,
        Pick<OpenApiSchemaPromocodeGroup, 'status'> {}

const statusMap: Record<OpenApiSchemaPromocodeGroup['status'], string> = {
    [PROMOACTIONS_STATUSES.active]: 'Активна',
    [PROMOACTIONS_STATUSES.inactive]: 'Не активна',
};

export const PromoactionStatusLabel = memo<PromocodeStatusLabelProps>(function PromocodeStatusLabel({
    'data-testid': dataTestId = 'PromoactionStatusLabel',
    status,
    ...labelProps
}) {
    const iconNode = useMemo(() => {
        const { Icon, baseProps } = STATUS_ICON_MAP[status];

        return <Icon {...baseProps} role="main" size="12" />;
    }, [status]);

    return (
        <Label data-testid={dataTestId} addonLeft={iconNode} {...labelProps}>
            {statusMap[status] ?? status}
        </Label>
    );
});
